<template>
  <div class="mb-6">
    <v-checkbox
      class="ml-3 mt-0"
      v-model="enabledSublayer"
      color="secondary lighten-1"
      @change="changeEnabledSublayer"
      hide-details
      dark
      :disabled="layer.values_.disabled"
    >
      <template v-slot:label>
        <div class="d-flex align-center">
          <v-icon
            v-if="layer.values_.icon_params"
            style="height: 24px; width: 24px; border-radius: 50%"
            :style="`background-color: ${iconBackgroundColor}`"
            size="18"
            color="white"
            >{{ layer.values_.icon_params.class }}</v-icon
          >
          <div>
            <strong class="ml-2 white--text layer-title">{{
              layer.values_.name
            }}</strong>
          </div>
        </div>
      </template>
    </v-checkbox>

    <sub-menu-layer-pesticides
      class="pt-4"
      v-if="showPesticidesBtn"
      @changeInputMenu="changeLayersPesticides($event)"
    ></sub-menu-layer-pesticides>

    <SubMenuLayerErosion
      class="pt-4"
      v-if="showErosionBtn"
      @changeInputMenu="changeLayersErosion($event)"
    >
    </SubMenuLayerErosion>

    <sub-menu-diffuse-loads
      class="pt-4"
      v-if="showDiffuseBtn"
      @changeInputMenu="changeLayersDiffuse($event)"
    ></sub-menu-diffuse-loads>
    <SubMenuLayerRestrictions
      class="pt-4"
      v-if="showRestrictionsBtn"
      @changeInputMenu="changeLayersRestrictions($event)"
    ></SubMenuLayerRestrictions>

    <div v-if="enabledSublayer && layer.values_.id !== 9999">
      <layer-opacity
        :initialOpacity="initialOpacity"
        @changeOpacitySublayer="changeOpacitySublayer($event)"
      >
      </layer-opacity>
    </div>
  </div>
</template>

<script>
import SubMenuLayerPesticides from '@/components/common/NewMapMenu/SubMenuLayerPesticides';
import SubMenuLayerErosion from '@/components/common/NewMapMenu/SubMenuLayerErosion';
import SubMenuDiffuseLoads from '@/components/common/NewMapMenu/SubMenuDiffuseLoads';
import LayerOpacity from './LayerOpacity.vue';
import SubMenuLayerRestrictions from '@/components/common/NewMapMenu/SubMenuLayerRestrictions';

export default {
  name: 'LeftSubLayerMapMenu',
  props: ['layer'],
  components: {
    LayerOpacity,
    SubMenuLayerPesticides,
    SubMenuLayerErosion,
    SubMenuDiffuseLoads,
    SubMenuLayerRestrictions
  },
  data: () => ({
    enabledSublayer: undefined,
    initialOpacity: undefined,
  }),
  created() {
    this.enabledSublayer = this.layer.values_.visible;
    this.initialOpacity = this.layer.values_.opacity * 100;
  },
  computed: {
    htmlCaption() {
      return this.layer.values_.caption_html &&
        (this.layer.values_.caption_html.alwaysVisible || this.enabledSublayer)
        ? this.layer.values_.caption_html
        : undefined;
    },
    showPesticidesBtn() {
      return this.layer.values_.name == 'Agrotóxico' && this.enabledSublayer;
    },
    showErosionBtn() {
      return this.layer.values_.name == 'Erosão' && this.enabledSublayer;
    },
    showDiffuseBtn() {
      return (
        this.layer.values_.name == 'Cargas Difusas' && this.enabledSublayer
      );
    },
    iconBackgroundColor() {
      return this.layer?.values_?.icon_params?.background_color ?? '';
    },
    showRestrictionsBtn() {
      return (
        this.layer.values_.name == 'Restrições Ambientais' && this.enabledSublayer
      );
    },
  },
  methods: {
    changeTimeFeature(timeFeature) {
      this.$emit('changeInputMenu', {
        eventName: 'changeTimeFeature',
        params: timeFeature,
      });
    },
    changeEnabledSublayer(visible) {
      this.$emit('changeInputMenu', {
        eventName: 'changeEnabledSublayer',
        params: {visible, layerId: this.layer.values_.id},
      });

      if (this.layer.values_.id === 735) {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 736},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 737},
        });
      }
      if (this.layer.values_.id === 500) {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 501},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 502},
        });
      }
      if (this.layer.values_.id === 503) {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 504},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 505},
        });
      }

      if (this.layer.values_.id === 400) {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 401},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 402},
        });

        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 403},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 404},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 405},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 406},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 407},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 408},
        });
      }
    },
    changeOpacitySublayer(opacity) {
      this.$emit('changeInputMenu', {
        eventName: 'changeOpacitySublayer',
        params: {opacity, layerId: this.layer.values_.id},
      });
      if (this.layer.values_.id === 735) {
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 736},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 737},
        });
      }
      if (this.layer.values_.id === 500) {
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 501},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 502},
        });
      }
      if (this.layer.values_.id === 503) {
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 504},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 505},
        });
      }

      if (this.layer.values_.id === 400) {
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 401},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 402},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 403},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 404},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 405},
        });

        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 406},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 407},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeOpacitySublayer',
          params: {opacity, layerId: 408},
        });

      }
    },
    changeLayersPesticides(event) {
      this.$emit('changeLayersPesticides', event);
    },
    changeLayersErosion(event) {
      this.$emit('changeLayersErosion', event);
    },
    changeLayersDiffuse(event) {
      this.$emit('changeLayersDiffuse', event);
    },
    changeLayersRestrictions(event) {
      this.$emit('changeLayersRestrictions', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-group {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 20px;
  /* or 154% */
  color: #ffffff;
}

.legend-group {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 15.1515px;
  line-height: 19px;
  color: #ffffff;
}
</style>
